import type { LoggerProvider, LogPayload } from '../core/types';

export class ConsoleProvider implements LoggerProvider {
  log(payload: LogPayload): void {
    switch (payload.level) {
      case 'info':
        console.info('[Logger]', payload);
        break;
      case 'warn':
        console.warn('[Logger]', payload);
        break;
      case 'error':
      case 'critical':
        console.error('[Logger]', payload);
        break;
    }
  }
}
